// extracted by mini-css-extract-plugin
module.exports = {"container":"Documents_container__JwP_V","isOpen":"Documents_isOpen__1P5Ju","icon":"Documents_icon__8rmYk","link":"Documents_link__3PSMU"};